const pluralize = require('pluralize')

export const pluralizeWord = (word: string, count: number) => {
  return pluralize(word, count)
}
